export const version="0.0.1"


export const serverURL = 'https://sams2.bds.hk';//'http://localhost:81';
//eslint-disable-next-line
export const DomainUser=(/^(http)(s){0,1}:\/\/[A-Za-z\:0-9]+\.[A-Za-z\:0-9]{3,}(\.[A-Za-z\:0-9]{2,}){0,1}$/.test(serverURL)?serverURL:'http://localhost:81')+"/api/users";

